import { Injectable, NgZone } from '@angular/core';
import firebase from 'firebase/compat/app';
import { AngularFirestore, AngularFirestoreDocument } from "@angular/fire/compat/firestore";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { NotificationsService } from './notifications.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  userData: any; // Save logged in user data

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    public router: Router,
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private notificationsService: NotificationsService,
  ) {
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
      } else {
        localStorage.setItem('user', '');
      }
    });

    this.afAuth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult(true);
      }
    });
  }

  // Sign in with email/password
  signIn(email: string, password: string): any {
    return this.afAuth.signInWithEmailAndPassword(email, password);
  }
  async register(email:string,password:string){
    const authuser= await this.afAuth.createUserWithEmailAndPassword(email,password);
    const uid=authuser.user?.uid;
    return uid
  }

  getCurrentUser(): any {
    return firebase.auth().currentUser;
  }


  async getUserCustomClaims() {
    let claims: any = {};
    const user = await this.afAuth.authState.pipe(take(1)).toPromise();
    if (user) {
      const tokenResult = await user?.getIdTokenResult();
      if (tokenResult) {
        const roles = tokenResult.claims['roles'] || null;
        claims = {
          claims: tokenResult.claims,
          roles,
          user
        };
      }
    }
    return claims;
  }

  // Reset Forggot password
  forgotPassword(passwordResetEmail: string): any {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        this.notificationsService.success('Password reset email sent, check your inbox.');
      }).catch((error) => {
        this.notificationsService.error(error.message);
      });
  }

  // Returns true when user is looged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return (user !== null) ? true : false;
  }


  setUserData(user: { uid: any; email: any; displayName: any; photoURL: any; emailVerified: any; }): any {
	  const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
	  const userData: any = {
	    uid          : user.uid,
	    email        : user.email,
	    displayName  : user.displayName,
	    photoURL     : user.photoURL,
	    emailVerified: user.emailVerified
	  };
	  return userRef.set(userData, {
	    merge: true
	  });
	}



  // Sign out
  signOut(): any {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['/auth/login']);
    });
  }
}
